export const MS_GROUPED_SKU = 'MASSSTORAGE'

export const MS_BASE_UNIT_SKU = 'MASSSTORAGE-BUNDLE'

export const MS_CONFIG_SKU = 'MASSSTORAGE-CONFIG'

export const MS_ADDON_SKU = 'MASSSTORAGE-ADD-ON-BUNDLE'

export const MS_4_PACK_WHEEL_SKU = "RF0359"
export const MS_2_PACK_WHEEL_SKU = "RA0331"

export const MS_4_PACK_BOLT_KIT_SKU = "RA0414"
export const MS_16_PACK_BOLT_KIT_SKU = "RA3615"

export const MS_CORNER_2_PACK_SKU = 'RA1677'
export const MS_CORNER_3_PACK_SKU  = 'RA1613'

// EUR/GBR Mass Storage bundle children are distinct Magento products with an 'EU-' prefix; MS_GROUPED_SKU never gets it, and MMS's EU catalog doesn't follow this convention at all.
export const withMsSitePrefix = (sku: string, siteCode: string | undefined): string =>
  (siteCode && ['EUR', 'GBR'].includes(siteCode) ? `EU-${sku}` : sku)

// Hardcoded to include both the US and EU- sku forms, since a real sku is always exactly one of the two — use withMsSitePrefix instead when resolving the one correct sku for the current site.
export const MS_BASE_UNIT_SKUS = [MS_BASE_UNIT_SKU, `EU-${MS_BASE_UNIT_SKU}`]
export const MS_ADDON_SKUS = [MS_ADDON_SKU, `EU-${MS_ADDON_SKU}`]
export const MS_CONFIG_SKUS = [MS_CONFIG_SKU, `EU-${MS_CONFIG_SKU}`]
export const MS_BOLT_KIT_SKUS = [
  MS_4_PACK_BOLT_KIT_SKU, `EU-${MS_4_PACK_BOLT_KIT_SKU}`,
  MS_16_PACK_BOLT_KIT_SKU, `EU-${MS_16_PACK_BOLT_KIT_SKU}`,
]
export const MS_4_PACK_WHEEL_SKUS = [MS_4_PACK_WHEEL_SKU, `EU-${MS_4_PACK_WHEEL_SKU}`]
export const MS_2_PACK_WHEEL_SKUS = [MS_2_PACK_WHEEL_SKU, `EU-${MS_2_PACK_WHEEL_SKU}`]
export const MS_CORNER_2_PACK_SKUS = [MS_CORNER_2_PACK_SKU, `EU-${MS_CORNER_2_PACK_SKU}`]
export const MS_CORNER_3_PACK_SKUS = [MS_CORNER_3_PACK_SKU, `EU-${MS_CORNER_3_PACK_SKU}`]

export const MS_GROUP_CHILD_SKUS = [...MS_BASE_UNIT_SKUS, ...MS_ADDON_SKUS, ...MS_BOLT_KIT_SKUS]

export const MSUnit = [MS_GROUPED_SKU, ...MS_ADDON_SKUS, ...MS_BASE_UNIT_SKUS]
